module.exports = __webpack_public_path__ + "static/media/error.ff2acdbc.svg";